module.exports = __webpack_public_path__ + "media/bootstrap-icons/three-dots-c67cff18.svg";